import React from 'react';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const ServiceBox = ({ 
  title, 
  description, 
  cost, 
  viewText = "View",
  showCost = true,
  customContent,
  className = "",
  id
}) => {
  return (
    <div className={`bg-white border border-slate-200 rounded-xl p-4 ${className}`}>
      <div className="flex justify-between items-center">
        <p className="text-slate-500 text-base font-semibold">
          {title}
        </p>
        <span className="text-primary cursor-pointer text-sm"><Link to={`/service/${id}/details`}>{viewText}</Link></span>
      </div>
      
      {customContent ? (
        customContent
      ) : (
        <p className="w-full text-slate-600 placeholder:text-slate-600 placeholder:opacity-50 resize-none outline-none rounded-lg p-2 duration-300 focus:border-slate-600">
          {description}
        </p>
      )}

      {showCost && (
        <div className=" border-slate-200 ">
          <span className="flex text-slate-500 items-center gap-2">
            {/* <CalendarTodayIcon fontSize="small" /> Cost: <span className="text-slate-500 text-sm ml-1">{cost}</span> */}
          </span>
        </div>
      )}
    </div>
  );
};

ServiceBox.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  cost: PropTypes.string,
  viewText: PropTypes.string,
  showCost: PropTypes.bool,
  customContent: PropTypes.node,
  className: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default ServiceBox; 